import axios from 'axios'
import { getBackendUrl } from './general'

export const sendElectronicDocument = async (context, idDocument, typeDocument) => {
    try {
        await context.$store.dispatch("statusLogin", context.$router);

        const { source } = await getBackendUrl();
        const res = await axios.post(
            `${source}/movimientos/api/enviarDocumentoElectronico`,
            {
                Id_Documento: idDocument,
                Tipo_Documento: typeDocument
            },
            {
                headers: {
                    "Authorization": `Bearer ${context.$store.state.user.token}`
                }
            }
        );

        return res.data;
    } catch (err) {
        console.log(err);
        throw err.response;
    }
}

export const sendMailElectronicDocument = async (context, idDocument, emailsCopy) => {
    try {
        await context.$store.dispatch("statusLogin", context.$router);
        const { source } = await getBackendUrl();
        const res = await axios.post(
            `${source}/movimientos/api/enviarCorreoDocumentoElectronico`,
            {
                Id_Documento: idDocument,
                Correos_Copia: emailsCopy
            },
            {
                headers: {
                    "Authorization": `Bearer ${context.$store.state.user.token}`
                }
            }
        );

        return res.data;
    } catch (err) {
        console.log(err);
        throw err.response;
    }
}

export const sendElectronicDocumentEvent = async (context, requestData ) => {
  try {
    await context.$store.dispatch("statusLogin", context.$router);
    const { source } = await getBackendUrl();
    const res = await axios.post(
      `${source}/movimientos/api/enviarEventoDocumentoElectronico`,
      requestData,
      {
        headers: {
          "Authorization": `Bearer ${context.$store.state.user.token}`
        }
      }
    );

    return res.data;
  } catch (err) {
    throw err.response;
  }
}

export const convertQuoteToOrder = async (context, data) => {
    try {
      await context.$store.dispatch("statusLogin", context.$router);
      const { source } = await getBackendUrl();
      const res = await axios.post(
        `${source}/movimientos/api/convertirCotizacion`,
        data,
        {
          headers: {
            "Authorization": `Bearer ${context.$store.state.user.token}`
          }
        }
      );
  
      return res.data;
    } catch (err) {
      throw err.response;
    }
}

export const processSerialFile = async (context, data) => {
  try {
    await context.$store.dispatch("statusLogin", context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/movimientos/api/xxx`,
      data,
      {
        headers: {
          "Authorization": `Bearer ${context.$store.state.user.token}`
        }
      }
    )

    return res.data
  } catch (err) {
    console.error(err)
    throw err.response
  }
}

export const importFileQuotesOrders = async (context, typeDocument, data) => {
  try {
    await context.$store.dispatch("statusLogin", context.$router);

    const { source } = await getBackendUrl();
    let endPointName = "";

    if (typeDocument === "Cotizacion") {
      endPointName = "cargaCotizacionExcel";
    } else if (typeDocument === "Pedido") {
      endPointName = "cargaPedidoExcel";
    } else {
      throw new Error("Tipo de documento no válido");
    }

    const res = await axios.post(
      `${source}/movimientos/api/${endPointName}`,
      data,
      {
        headers: {
          "Authorization": `Bearer ${context.$store.state.user.token}`
        }
      }
    );

    return res.data;
  }
  catch (err) {
    console.error(err);
    throw err.response;
  }
}

export const importFileElectronicDocuments = async (context, data) => {
  try {
    await context.$store.dispatch("statusLogin", context.$router);

    const { source } = await getBackendUrl();
    const res = await axios.post(
      `${source}/movimientos/api/procesaDocumentosDIAN`,
      data,
      {
        headers: {
          "Authorization": `Bearer ${context.$store.state.user.token}`
        }
      }
    );

    return res.data;
  } catch (err) {
    console.error(err);
    throw err.response;
  }
}


// export const crudMovimientoPedidoCotizacion = async (context, typeAction, id, requestBody) => {
//   try {
//     await context.$store.dispatch('statusLogin', context.$router);
//     const { source } = await getBackendUrl();
//     const endPoint = "/movimientos/api/movimientoPedido/";
//     const urlService = `${source}${endPoint}`;
//     const paramsHeader = {
//       "Authorization": `Bearer ${context.$store.state.user.token}`
//     };
//     let response;

//     switch (typeAction) {
//       case "create":
//         response = await axios.post(
//           `${urlService}`,
//           requestBody,
//           {
//             headers: paramsHeader
//           }
//         );
//         break;
//       case "read":
//         break;
//       case "update":
//         break;
//       case "delete":
//         response = await axios.delete(
//           `${urlService}${id}/`,
//           {
//             headers: paramsHeader
//           }
//         );
//         break;
//     }

//     return response.data;
//   } catch (err) {
//     console.log(err);
//     throw err.response;
//   }
// }
